import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { assignInboxWorker, moveInboxItem, type InboxMoveTarget } from "@/lib/inboxOwners";
import { InboxOwnerPicker, validInboxOwner } from "./InboxOwnerPicker";

export function InboxWorkerAssignment({ itemId, scanned = false, onAssigned, onBusy }: { itemId: string; scanned?: boolean; onAssigned: () => void; onBusy: (busy: boolean) => void }) {
  const { can } = useAuth(); const [target, setTarget] = useState<InboxMoveTarget | null>(null);
  const [busy, setBusy] = useState(false); const [error, setError] = useState<string | null>(null); const running = useRef(false);
  async function assign(value: InboxMoveTarget | null) {
    if (!validInboxOwner(value, can) || running.current) return;
    running.current = true; setBusy(true); onBusy(true); setError(null);
    try { if (scanned) await moveInboxItem(itemId, value); else if (value.owner_kind === "radnik" && value.radnik_id) await assignInboxWorker(itemId, value.radnik_id); else return; onAssigned(); }
    catch (cause: unknown) { setError(errorMessage(cause, "Dodjela nije uspjela. Odabir je sačuvan.")); }
    finally { running.current = false; setBusy(false); onBusy(false); }
  }
  return <section aria-label="Dodjela nositelja" className="avm-surface space-y-2 rounded border bg-muted/30 p-2">
    <p>Dodijelite nositelja ovoj stavci.</p>
    <InboxOwnerPicker allowCompany={scanned} value={target} onChange={setTarget} disabled={busy} onCreated={(created) => void assign(created)} />
    <Button disabled={busy || !validInboxOwner(target, can)} onClick={() => void assign(target)}>Potvrdi nositelja stavke</Button>
    {error && <p role="alert">{error}</p>}
  </section>;
}
